<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2024-02-29 17:16:04
 * @LastEditors: sunyan 1055697528@qq.com
 * @LastEditTime: 2024-04-16 14:07:03
 * @FilePath: \jsczt_vue20240117\src\views\moblie\list.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="background: #f2f5f7;">
    <div class="head">
      <div class="head_logo">
          <img src="../../assets/jscztmb_logo.png" alt="" />
      </div>
      <div class="head_name">
          江苏省预决算公开统一平台
      </div>
      <div class="head_nav">
          <div
            v-for="tab in tabs"
            :key="tab.id"
            :class="activeTab === tab.id? 'nav_btn actives':'nav_btn'"
            @click="changeTab(tab.id)">
          {{ tab.name }}
          </div>
        </div>
    </div>
    <div class="content">
      <div class="contentTit">{{downList.title}}</div>
      <div  v-if="content" v-html="content" style="cursor: text;" class="contentTit"></div>
      <ul v-if="fileList.length>1">
          详情见附件:
          <li v-for="(item,index) in fileList" :key="item.fileid">
            <div class="list_txt">附件{{ index+1 }} <span style="margin-left: 15PX;">{{ item.appdesc }}</span></div>
            <div class="btn_box">
              <div class="list_btn">
                <!-- <a :href="item.appfile" :download="item.appdesc" @click="downClick(item)">下载</a> -->
                <a :href="item.appfile" class="downList" :download="item.appdesc" @click="downClick(item)">下载</a>
              </div>
              <!-- <div class="list_btn" style="background-color: #caa06d !important;" v-if="item.type === 'pdf'" @click="filePreview(item.appfile)">预览</div> -->
            </div>
          </li>
        </ul>
        <ul class="preview" v-if="fileList.length === 1&&fileList[0].type == 'pdf'" style="margin-top: 20PX;">
          详情见附件:
          <div class="preFile">
            {{ fileList[0].appdesc }}
            <span class="down_btn">
              <!-- <span @click.stop="gotoOption('downLoad', item['article'], index)"><i class="iconfont iconxiazai1"></i>下载</span> -->
              <!-- <a :href="fileList[0].appfile" :download="fileList[0].appdesc" @click="downClick(fileList)">下载</a> -->
              <a :href="fileList[0].appfile" :download="fileList[0].appdesc"  @click="downClick(fileList)">下载</a>
            </span>
          </div>
          <li> 
            <iframe :src="fileList[0].appfile" frameBorder=0 width="100%" height="600PX"></iframe>
            <!-- <div class="pdfbox"> -->
              <!-- <pdf
                ref="pdf"
                v-for="item in numPages"
                :key="item"
                :src="fileList[0].appfile"
                :page="item"
                :scale="scale"
                >
              </pdf> -->
            <!-- </div> -->
          </li>
        </ul>
        <ul v-if="fileList.length === 1&&fileList[0].type != 'pdf'">
          详情见附件:
          <li v-for="(item,index) in fileList" :key="item.fileid">
            <div class="list_txt">附件{{ index+1 }} <span style="margin-left: 15PX;">{{ item.appdesc }}</span></div>
            <div class="btn_box">
              <div class="list_btn">
                <a :href="item.appfile" class="downList" :download="item.appdesc" @click="downClick(item)">下载</a>
              </div>
            </div>
          </li>
        </ul>
        <van-dialog v-model="fileDialog" title="预览" show-cancel-button>
          <div class="pdfbox">
            <pdf
          ref="pdfs"
          v-for="item in numPages"
          :key="item"
          :src="curPdf"
          :page="item"
          :scale="scale"
          >
        </pdf>
            </div>
        </van-dialog>
    </div>
    
    <div class="footers">
      主办：江苏省财政厅 备案序号：苏ICP备15009401号 公安备案号：32010602010331
      网站标识码：3200000098 江苏省财政厅版权所有
    </div>
  </div>
</template>

<script>
import Pdf from 'vue-pdf'
export default {
  name: 'index',
  components: {
    Pdf
  },
  data () {
    return {
      downList:[],
      fileList:[],
      activeTab: '5',
      content:'',
      fileDialog:false,
      curPdf: '',
      scale: 1,
      // scaled: 1, // 初始缩放比例
      numPages: null,
      tabs: [
        { name: '预决算公开管理文件', id: '5' },
        { name: '政府预决算公开', id: '8' },
        { name: '部门预决算公开', id: '25' }
      ],
    }
  },

  watch: {

  },
  created () {
  },
  mounted () {
    this.getDetail()
    this.update()
  },
  methods: {
    update(){
      // this.title=this.$store.state.sjName
      this.activeTab=this.$store.state.sjParentid
    },
    gotoOption (val, item, index) {
      if (val === 'collect') {
        this.collectReport(item, index)
      } else if (val === 'downLoad') {
        this.downloadWeekly(item['local_access_full-text-link'], item['article_article-title'], item['uuid'])
      }
    },
     // 详情
    async getDetail () {
      await this.$http.get('/api/yjsgk/findDataById', {
        params: {
          metadataId: this.$route.query.id
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.downList=res.data.data
          // console.log(this.downList )
          // this.cname = res.data.data.title
          this.content = res.data.data.content
          this.fileList = res.data.data.fileList
          this.fileList.forEach(item => {
            const lastIndex = item.appdesc.lastIndexOf('.')
            item.type = item.appdesc.substring(lastIndex + 1)
            // console.log(item.appfile,lastIndex,item.type)
            // this.getnumPages(item.appfile)
            item.count = this.numPages
          })
        }
      })
    },
     // 预览
     filePreview (url) {
      this.curPdf = url
      this.getnumPages(url)
      this.fileDialog = true
    },
    // 计算页数
    getnumPages (file) {
      let loadingTask = Pdf.createLoadingTask(file)
      // console.log(loadingTask)
      loadingTask.promise.then(Pdf => {
        this.numPages = Pdf.numPages
      }).catch(err => {
        console.log(err)
      })
    },
    changeTab (id) {
      this.activeTab = id
      this.$store.commit('setSjParentid',id)
      this.$router.push({name:'list'})
    },
    onChange (picker, value, index) {
      console.log(value)
    },
    changeYear () {
      this.show = true
    },
    downClick(item){
      let detailParams=this.$store.state.detailParams
      // console.log(detailParams)
      var paramsList={
        browserVersion:navigator.appVersion,
    browserName: navigator.appName,
    browserLanguage:navigator.language,
    areaCode:this.downList.areacode,
    areaName:detailParams.areaName,
    deptCode:detailParams.deptCode,
    deptName:detailParams.deptName,
    unitCode:detailParams.unitCode,
    unitName:detailParams.unitName,
    areaYear:detailParams.year=='自定义'?this.$store.state.startYear+","+this.$store.state.endYear:detailParams.year,
    sourceType:5,
    fileType:this.$store.state.sjFileType,
    docId:item[0].appdocid,
    title:this.downList.title,
    channelId:this.downList.channelId,
    url:item[0].appfile,
    appendixId:item[0].fileid,
    appendixName:item[0].appdesc
        }
      this.$http.post('/yjsUbas/yjs/add',paramsList ).then(res => {
          // if (res.data.code === 200) {
            // this.listData = res.data.data
          }
        )
    }
  }
}
</script>
<style scoped>
@import url("../../assets/list.css");
.downList{
  margin-left:10px;
  display:inline-block;
  width:30px;
  height:20px;
}
</style>



// WEBPACK FOOTER //
// src/views/moblie/detail.vue